import { useRef, useState } from "react";
import { UploadCloud, Loader2, X } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { toast } from "sonner";

// Uploads a single file (image or video) and returns the stored relative URL via onChange.
export default function Uploader({ value, onChange, accept = "image/*", label = "Subir archivo", testid = "uploader" }) {
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);
  const isVideo = accept.includes("video");

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    const form = new FormData();
    form.append("file", file);
    try {
      const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Archivo subido");
    } catch (err) {
      toast.error("No se pudo subir el archivo");
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      {value ? (
        <div className="relative inline-block">
          {isVideo ? (
            <video src={mediaUrl(value)} className="h-36 rounded-md border border-paper-200" />
          ) : (
            <img src={mediaUrl(value)} alt="preview" className="h-36 rounded-md border border-paper-200 object-cover" />
          )}
          <button type="button" onClick={() => onChange("")} className="absolute -top-2 -right-2 bg-nasa-red rounded-full p-1 text-white" data-testid={`${testid}-remove`}>
            <X size={14} />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => ref.current?.click()}
          disabled={loading}
          data-testid={testid}
          className="flex items-center gap-2 px-4 py-3 rounded-md border border-dashed border-paper-300 bg-paper-50 text-ink-700 hover:border-nasa-blue hover:text-nasa-blue transition-colors text-sm"
        >
          {loading ? <Loader2 size={18} className="animate-spin" /> : <UploadCloud size={18} />}
          {loading ? "Subiendo…" : label}
        </button>
      )}
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={handle} />
    </div>
  );
}
